import React, { useState, useEffect, useRef, } from "react";
import { FaMapMarkerAlt, FaStar, FaUtensils } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Cateringall from "../Cateringall";
import "./RestaurantCards.css";
import Catreningitem from '../Catreningitem';
import menu1 from "../Digitalfood/pumpkin-1768857_1280.jpg";
import SidescrollAdvertisements from '../Digitalfood/SidescrollAdvertisements.js';
import { FaArrowRight } from "react-icons/fa"; //
import Logisticsserivices from "./Logisticsserivices";

import { ThemeProvider, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Cloudsidebar from "./Cloudsidebar"; // adjust path




import miniTruckImg from "../Digitalfood/Franchiesimages/mini.png";
import tempoImg from "../Digitalfood/auto.jpg";
import containerImg from "../Digitalfood/Franchiesimages/motor8.png";
import pickupImg from "../Digitalfood/Franchiesimages/MIDUAM5.webp";
import vanImg from "../Digitalfood/Franchiesimages/motor2.jpg";
import openTruckImg from "../Digitalfood/MIDUAM2.webp";
import trailerImg from "../Digitalfood/Franchiesimages/motor3.jpg";
import tankerImg from "../Digitalfood/Franchiesimages/MIDIUM1.png";

import sedanImg from "../Digitalfood/Franchiesimages/b1.png";
import suvImg from "../Digitalfood/Franchiesimages/si.png";
import miniBusImg from "../Digitalfood/Franchiesimages/midibus.png";
import luxuryBusImg from "../Digitalfood/Franchiesimages/BUS3.png";
import autoImg from "../Digitalfood/auto.jpg";
import bikeTaxiImg from "../Digitalfood/Franchiesimages/HONDA7.jpg";
import electricCabImg from "../Digitalfood/Franchiesimages/elec.png";

import driver1Img from "../Digitalfood/Franchiesimages/driver.webp";
import driver2Img from "../Digitalfood/Franchiesimages/busdrive.webp";
import driver3Img from "../Digitalfood/Franchiesimages/driver.webp";
import driver4Img from "../Digitalfood/Franchiesimages/busdrive.webp";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";


import { FaTruck, FaCar, FaBus, FaMotorcycle, FaShuttleVan } from "react-icons/fa";

import Modal from "react-modal";
const BASE_URL = " https://backend.maamaas.com/food";

Modal.setAppElement("#root"); // Important for accessibility

const vehiclesData = [
  // ---------------- GOODS VEHICLES (10) ----------------
  {
    id: 1,
    type: "GOODS",
    name: "Mini Truck",
    capacity: "500kg",
    distance: "20km",
    deliveryType: "SAME_DAY",
    price: 1200,
    image: miniTruckImg,
  },
  {
    id: 2,
    type: "GOODS",
    name: "Tempo",
    capacity: "1000kg",
    distance: "50km",
    deliveryType: "EXPRESS",
    price: 1800,
    image: tempoImg,
  },
  {
    id: 3,
    type: "GOODS",
    name: "Container Truck",
    capacity: "5000kg",
    distance: "200km",
    deliveryType: "STANDARD",
    price: 5000,
    image: containerImg,
  },
  {
    id: 4,
    type: "GOODS",
    name: "Pickup Van",
    capacity: "700kg",
    distance: "30km",
    deliveryType: "SAME_DAY",
    price: 1500,
    image: pickupImg,
  },
  {
    id: 5,
    type: "GOODS",
    name: "Closed Delivery Van",
    capacity: "1200kg",
    distance: "100km",
    deliveryType: "EXPRESS",
    price: 2200,
    image: vanImg,
  },
  {
    id: 6,
    type: "GOODS",
    name: "Open Truck",
    capacity: "3000kg",
    distance: "150km",
    deliveryType: "SCHEDULED",
    price: 3500,
    image: openTruckImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-21", "2025-09-22"],
  },
  {
    id: 7,
    type: "GOODS",
    name: "Trailer Truck",
    capacity: "15000kg",
    distance: "500km",
    deliveryType: "STANDARD",
    price: 12000,
    image: trailerImg,
  },
  {
    id: 8,
    type: "GOODS",
    name: "Tanker Lorry",
    capacity: "10000L",
    distance: "400km",
    deliveryType: "SCHEDULED",
    price: 10000,
    image: tankerImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-23", "2025-09-25"],
  },
  {
    id: 9,
    type: "GOODS",
    name: "Refrigerated Van",
    capacity: "800kg",
    distance: "60km",
    deliveryType: "SCHEDULED",
    price: 2800,
    image: tankerImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-22", "2025-09-24"],
  },
  {
    id: 10,
    type: "GOODS",
    name: "Heavy Duty Truck",
    capacity: "20000kg",
    distance: "600km",
    deliveryType: "SCHEDULED",
    price: 15000,
    image: tankerImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-26", "2025-09-27"],
  },

  // ---------------- PASSENGER VEHICLES (15) ----------------
  {
    id: 11,
    type: "PASSENGER",
    name: "Sedan Taxi",
    passengers: 4,
    rideType: "TRIP",
    price: 800,
    image: sedanImg,
  },
  {
    id: 12,
    type: "PASSENGER",
    name: "SUV Ride",
    passengers: 6,
    rideType: "RENTALS",
    price: 1500,
    image: suvImg,
  },
  {
    id: 13,
    type: "PASSENGER",
    name: "Mini Bus",
    passengers: 20,
    rideType: "GROUP",
    price: 3500,
    image: miniBusImg,
  },
  {
    id: 14,
    type: "PASSENGER",
    name: "Luxury Bus",
    passengers: 40,
    rideType: "GROUP",
    price: 8000,
    image: luxuryBusImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-20", "2025-09-22"],
  },
  {
    id: 15,
    type: "PASSENGER",
    name: "Auto Rickshaw",
    passengers: 3,
    rideType: "TRIP",
    price: 200,
    image: autoImg,
  },
  {
    id: 16,
    type: "PASSENGER",
    name: "Bike Taxi",
    passengers: 1,
    rideType: "TRIP",
    price: 100,
    image: bikeTaxiImg,
  },
  {
    id: 17,
    type: "PASSENGER",
    name: "Electric Cab",
    passengers: 4,
    rideType: "RESERVE",
    price: 900,
    image: electricCabImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-21", "2025-09-22"],
  },
  {
    id: 18,
    type: "PASSENGER",
    name: "Luxury Van",
    passengers: 8,
    rideType: "SCHEDULED",
    price: 2500,
    image: suvImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-23", "2025-09-24"],
  },
  {
    id: 19,
    type: "PASSENGER",
    name: "Tourist Coach",
    passengers: 50,
    rideType: "GROUP",
    price: 12000,
    image: luxuryBusImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-25", "2025-09-26"],
  },
  {
    id: 20,
    type: "PASSENGER",
    name: "Premium Taxi",
    passengers: 4,
    rideType: "SCHEDULED",
    price: 1500,
    image: luxuryBusImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-27", "2025-09-28"],
  },
  {
    id: 21,
    type: "PASSENGER",
    name: "Shuttle Van",
    passengers: 12,
    rideType: "GROUP",
    price: 2000,
    image: luxuryBusImg,
  },
  {
    id: 22,
    type: "PASSENGER",
    name: "Shared Cab",
    passengers: 3,
    rideType: "POOL",
    price: 400,
    image: sedanImg,
  },
  {
    id: 23,
    type: "PASSENGER",
    name: "Electric Bus",
    passengers: 35,
    rideType: "SCHEDULED",
    price: 6000,
    image: sedanImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-21", "2025-09-23"],
  },
  {
    id: 24,
    type: "PASSENGER",
    name: "Airport Shuttle",
    passengers: 10,
    rideType: "SCHEDULED",
    price: 2200,
    image: sedanImg,
    scheduledAvailable: true,
    availableDates: ["2025-09-24", "2025-09-25"],
  },
  {
    id: 25,
    type: "PASSENGER",
    name: "Corporate Cab",
    passengers: 4,
    rideType: "RESERVE",
    price: 2000,
    image: sedanImg,
  },
];



// Sample Drivers Data
const driversData = [
  {
    id: 1,
    name: "Ramesh Kumar",
    type: "Heavy Vehicle Driver",
    experience: "5 years",
    licenseType: "Heavy Motor Vehicle",
    salary: "₹25,000 / month",
    image: driver1Img,
  },
  {
    id: 2,
    name: "Amit Sharma",
    type: "Car Driver",
    experience: "3 years",
    licenseType: "LMV",
    salary: "₹18,000 / month",
    image: driver2Img,
  },
  {
    id: 3,
    name: "Suresh Yadav",
    type: "Bus Driver",
    experience: "7 years",
    licenseType: "Passenger Bus",
    salary: "₹28,000 / month",
    image: driver3Img,
  },
  {
    id: 4,
    name: "Vikas Singh",
    type: "Chauffeur",
    experience: "4 years",
    licenseType: "LMV + Commercial",
    salary: "₹22,000 / month",
    image: driver4Img,
  },
  {
    id: 5,
    name: "Ramesh Kumar",
    type: "Heavy Vehicle Driver",
    experience: "5 years",
    licenseType: "Heavy Motor Vehicle",
    salary: "₹25,000 / month",
    image: driver1Img,
  },
  {
    id: 6,
    name: "Amit Sharma",
    type: "Car Driver",
    experience: "3 years",
    licenseType: "LMV",
    salary: "₹18,000 / month",
    image: driver2Img,
  },
  {
    id: 7,
    name: "Suresh Yadav",
    type: "Bus Driver",
    experience: "7 years",
    licenseType: "Passenger Bus",
    salary: "₹28,000 / month",
    image: driver3Img,
  },
  {
    id: 8,
    name: "Vikas Singh",
    type: "Chauffeur",
    experience: "4 years",
    licenseType: "LMV + Commercial",
    salary: "₹22,000 / month",
    image: driver4Img,
  },
];




const toImageSrc = (base64) => {
  return base64 ? `data:image/jpeg;base64,${base64}` : "";
};

const RestaurantCards = ({ cities }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Filter states
  const [search, setSearch] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [city, setCity] = useState("");
  const [subLocation, setSubLocation] = useState("");
  const [businessModel, setBusinessModel] = useState("");
  const [cuisine, setCuisine] = useState("");
  const [dietary, setDietary] = useState("");
  // const [filteredCards, setFilteredCards] = useState([]);
  const [subCategory, setSubCategory] = useState("");

  const userId = localStorage.getItem("userId");
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [subOffer, setSubOffer] = useState("");
  const [area, setArea] = useState("");
  const [pincode, setPincode] = useState("");
  const [nearby, setNearby] = useState("");
  const [eventType, setEventType] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [customizeMode, setCustomizeMode] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coupons, setCoupons] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const categories = ["Starters", "Mains", "Desserts", "Drinks"];

  const [activeStep, setActiveStep] = useState(1);


  const [customType, setCustomType] = useState("");

  const [cardsData, setCardsData] = useState([]);


  // 🔹 filtered vendors (to display in grid)


  const [filteredCards, setFilteredCards] = useState([]);
  const [selectedBusinessType, setSelectedBusinessType] = useState("");
  const [selectedOutletType, setSelectedOutletType] = useState("");
  const [selectedLogisticsType, setSelectedLogisticsType] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [submittedData, setSubmittedData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [capacity, setCapacity] = useState("");
  // const [distance, setDistance] = useState("");
  const [deliveryType, setDeliveryType] = useState("");

  const [passengers, setPassengers] = useState("");
  const [rideType, setRideType] = useState("");
  const [pickupLocation, setPickupLocation] = useState("");
  const [dropLocation, setDropLocation] = useState("");
  const [cateringMode, setCateringMode] = useState("");
  const [scheduledDate, setScheduledDate] = useState("");

  const [scheduledTime, setScheduledTime] = useState(""); // ✅ add this line
  const [driverType, setDriverType] = useState("");
  const [licenseType, setLicenseType] = useState("");
  const [experience, setExperience] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [distance, setDistance] = useState(0);
  const [price, setPrice] = useState(null);
  const [showVehicles, setShowVehicles] = useState(false);
  const [priceCalculated, setPriceCalculated] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [markerPosition, setMarkerPosition] = useState({ lat: 17.385, lng: 78.4867 }); // Default Hyderabad
  const [confirmedPickup, setConfirmedPickup] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");

   const [locationType, setLocationType] = useState(""); // Home, Office, Current, Add
  
  const [showExtraFields, setShowExtraFields] = useState(false);

const theme = useTheme();
const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
const [open, setOpen] = useState(false);

const getToggleButtonLeft = () => (isSmallMobile ? 10 : 20);
const getIconSize = () => (isSmallMobile ? "small" : "medium");
const getSidebarWidth = () => (isDesktop ? 280 : 200);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    pickup: "",
    drop: "",
  });

  const countries = [
  "India",
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Japan",
  "China",
  "Brazil",
  // aur saare countries yahan add kar sakte hain
];

  const handleHireClick = (driver) => {
    setSelectedDriver(driver);
    setShowModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      `Booking Confirmed for ${selectedDriver?.name}\nName: ${formData.name}\nMobile: ${formData.mobile}\nPickup: ${formData.pickup}\nDrop: ${formData.drop}`
    );
    setShowModal(false);
  };


  // 🔹 filtered vendors (to display in grid)
  useEffect(() => {
    if (!selectedBranch) {
      setFilteredCards(cardsData);
    } else {
      setFilteredCards(cardsData.filter((card) => card.appType === selectedBranch));
    }
  }, [selectedBranch, cardsData]);



  // Map of sub-offers based on offer type
  const subOffersMap = {
    "General Discounts": [
      "Flat Discount (10%, 20%, 50% OFF)",
      "Buy 1 Get 1 (BOGO)",
      "Combo Deals",
    ],
    "Happy Hours Offers": [
      "Lunch Specials",
      "Dinner Discounts",
      "Late-night Offers",
      "Happy Hours (4–7 PM)",
      "Weekend Specials (Fri–Sun)",
    ],
    "Membership & Loyalty Offers": [
      "First-time User Discount",
      "Loyalty Points / Rewards",
      "Subscription Discounts (Monthly / Yearly Plans)",
      "Member-only Exclusive Deals",
    ],
    "Payment & Wallet-based Offers": [
      "Card Offers (Visa, Mastercard, Amex)",
      "Wallet Offers (Paytm, PhonePe, Google Pay)",
      "UPI Cashback",
      "Buy Now, Pay Later Discounts",
    ],
    "Special Occasion Offers": [
      "Festival Offers (Diwali, Christmas, Eid, New Year)",
      "Birthday / Anniversary Specials",
      "Student Discounts",
      "Corporate / Bulk Order Discounts",
    ],
    "Category-specific Offers": [
      "Buffet Discounts",
      "Takeaway Offers",
    ],
  };

  const handleBusinessModelChange = async (e) => {
    const selectedValue = e.target.value;
    setBusinessModel(selectedValue);

    const handleBusinessModelChange = (e) => {
      setBusinessModel(e.target.value);
      setCustomType(""); // reset input when option change
    };

    setSelectedPackage(null);
    setEventType("");
    setCuisine("");
    setDietary("");

    if (!selectedValue || !userId) return;

    try {
      await axios.post(
        `${BASE_URL}/api/cart/create/${userId}?orderType=${selectedValue}`
      );
    } catch (error) {
      console.error("Cart creation failed:", error);
    }
  };



  const handleCustomizeClick = () => {
    setCustomizeMode(true);
    setSelectedPackage(null);
  };

  const handleCityChange = (e) => {
    const city = e.target.value;
    setSelectedCity(city);
    if (city) setShowDetails(true);
  };


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {};
        if (city) params.city = city;
        if (subLocation) params.addressLine = subLocation;
        if (businessModel) params.orderType = businessModel;

        const queryString = new URLSearchParams(params).toString();
        const { data } = await axios.get(
          `${BASE_URL}/banner/getall${queryString ? `?${queryString}` : ""}`
        );

        const safe = (Array.isArray(data) ? data : []).map((b) => ({
          ...b,
          vendorId: b.vendorId || b.id,
          bannerUrl: toImageSrc(b.companyBanner),
          logoUrl: toImageSrc(b.companyLogo),
          addressLine: b.addressLine || "vv",
        }));

        setCards(safe);
        setFilteredCards(safe);
      } catch (e) {
        setError("Unable to load vendors.");
      } finally {
        setLoading(false);
      }
    })();
  }, [city, subLocation, businessModel]);

  useEffect(() => {
    let result = cards;

    if (search) {
      const searchTerm = search.toLowerCase();
      result = result.filter(
        (card) =>
          card.companyName.toLowerCase().includes(searchTerm) ||
          (card.subtitle &&
            card.subtitle.toLowerCase().includes(searchTerm)) ||
          (card.city && card.city.toLowerCase().includes(searchTerm))
      );
    }

    if (selectedBranch !== "All" && selectedBranch !== "") {
      result = result.filter(
        (card) => card.businessType === selectedBranch
      );
    }



    if (subCategory) {
      result = result.filter(
        (card) =>
          card.subtitle &&
          card.subtitle.toLowerCase().includes(subCategory.toLowerCase())
      );
    }

    setFilteredCards(result);
  }, [search, selectedBranch, subCategory, cards]);



  // Mobile resize check
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${BASE_URL}/banner/getall`);

        const safe = (Array.isArray(data) ? data : []).map((b) => ({
          ...b,
          vendorId: b.vendorId || b.id,
          bannerUrl: toImageSrc(b.companyBanner),
          logoUrl: toImageSrc(b.companyLogo),
          rating: (Math.random() * (5 - 3.5) + 3.5).toFixed(1),
          offer: "Flat 10% OFF",
          addressLine: b.addressLine || "Unknown Location",
          subtitle: b.subtitle || "North Indian, Chinese",
          Type: b.Type || "Restaurant",
          price: b.price || "₹2000 for two",
          distance: (Math.random() * 10).toFixed(1) + " km",
          promoted: true,
          appType: b.appType || "FOOD_AND_BEVERAGES", // 👈 ensure you store appType
        }));

        setCards(safe);
        setFilteredCards(safe);
      } catch (e) {
        setError("Unable to load vendors.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);



  useEffect(() => {
    let filtered = cards;

    if (selectedBusinessType) {
      filtered = filtered.filter((c) => c.appType === selectedBusinessType);
    }

    if (selectedOutletType) {
      filtered = filtered.filter((c) => c.Type?.toUpperCase() === selectedOutletType.toUpperCase());
    }

    setFilteredCards(filtered);
  }, [selectedBusinessType, selectedOutletType, cards]);
  const handleCardClick = (vendorId) => {
    localStorage.setItem("vendorId", vendorId);
    navigate(`/Maamaasuser/${vendorId}`);
  };




  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
            );
            const data = await res.json();

            setSelectedCity(
              data.address.city || data.address.town || ""
            );
            setArea(
              data.address.suburb || data.address.village || ""
            );
            setPincode(data.address.postcode || "");
          } catch (error) {
            console.error("Location fetch error:", error);
          }
        },
        (error) => {
          if (error.code === 1) {
            alert("⚠️ Location access denied.");
          } else if (error.code === 2) {
            alert("⚠️ Location unavailable.");
          } else if (error.code === 3) {
            alert("⚠️ Request timed out.");
          }
        }
      );
    } else {
      alert("❌ Geolocation not supported.");
    }
  };


  const businessSubCategories = {
    Restaurant: ["Fine Dining", "Casual Dining", "Cafe", "Fast Food"],
    FoodCourt: ["Franchise A", "Franchise B", "Franchise C"],
    FoodTruck: ["Truck A", "Truck B", "Truck C"],
    CloudKitchen: ["Staffing A", "Staffing B", "Staffing C"],
    Franchise: [
      "QSR Franchise",
      "Café Franchise",
      "Dessert / Ice Cream Franchise",
      "Bakery Franchise",
      "Juice / Beverage Franchise",
      "Multi-brand Food Court Franchise",
    ],
  };




  const btnStyle = {
    padding: "8px 14px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textAlign: "center",
    width: "100%",
    marginBottom: "8px",
  };


  const styles = {
    input: {
      padding: "12px",
      marginBottom: "12px",
      width: "100%",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px",
      outline: "none",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#007BFF",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "600",
      marginTop: "15px",
      transition: "0.2s",
    },
  };




  const clearAll = () => {
    // general
    setSearch("");
    setSelectedCity("");
    setArea("");
    setPincode("");
    setNearby("");

    // business
    setSelectedBusinessType("");
    setActiveStep(1);

    // logistics
    setSelectedLogisticsType("");
    setCapacity("");
    setDistance("");
    setDeliveryType("");
    setPassengers("");
    setRideType("");
    setPickupLocation("");
    setDropLocation("");
    setShowFilter(false);

    // catering/food
    setSelectedOutletType("");
    setCustomType("");
    setBusinessModel("");
    setCuisine("");
    setDietary("");
    setSelectedPackage(null);
    setCustomizeMode(false);
    setSelectedBranch("");
    setSubCategory("");
    setSubOffer("");
  };

  // Reset only fields that are irrelevant when business type changes
  const resetFieldsForBusinessType = (newType) => {
    // If switching away from logistics -> reset logistics fields
    if (newType !== "LOGISTICS") {
      setSelectedLogisticsType("");
      setCapacity("");
      setDistance("");
      setDeliveryType("");
      setPassengers("");
      setRideType("");
      setPickupLocation("");
      setDropLocation("");
      setShowFilter(false);
    }

    // If switching away from catering -> reset catering fields
    if (newType !== "CATERING_SERVICE") {
      setSelectedOutletType("");
      setCustomType("");
      setBusinessModel("");
      setCuisine("");
      setDietary("");
      setSelectedPackage(null);
      setCustomizeMode(false);
      setSelectedBranch("");
      setSubCategory("");
      setSubOffer("");
    }

    // If switching away from food & beverages / outlets -> reset those
    if (newType !== "FOOD_AND_BEVERAGES") {
      setSelectedOutletType("");
      setSelectedBranch("");
    }
  };

  // When user selects a business type
  const handleBusinessTypeChange = (newType) => {
    setSelectedBusinessType(newType);
    setActiveStep(2);

    // ✅ Reset common state
    setShowFilter(false);

    // ✅ Reset Catering
    setCuisine("");
    setDietary("");
    setCateringMode(null);

    // ✅ Reset Logistics
    setSelectedLogisticsType("");
    setCapacity("");
    setDistance("");
    setDeliveryType("");
    setScheduledDate("");
    setPassengers("");
    setRideType("");
    setPickupLocation("");
    setDropLocation("");

    // ✅ Reset Banquet / Franchise if needed
    // setBanquetType(""); setFranchise(""); ...
  };




  const filteredDrivers = driversData.filter((d) => {
    if (selectedLogisticsType !== "DRIVERS") return false;

    if (driverType && d.type !== driverType) return false;        // Driver Type
    if (licenseType && d.licenseType !== licenseType) return false; // License Type
    if (experience && parseInt(d.experience) < parseInt(experience)) return false; // Experience

    return true;
  });
  // Logistics: show pickup/drop only after required fields filled
  const filteredVehicles = vehiclesData.filter((v, d) => {
    // Agar logistics type select kiya gaya hai to us type ka hi ho
    if (selectedLogisticsType && v.type !== selectedLogisticsType) return false;

    // GOODS filters
    if (selectedLogisticsType === "GOODS") {
      if (capacity && !v.capacity.includes(capacity)) return false;
      if (distance && !v.distance.includes(distance)) return false;
      if (deliveryType && v.deliveryType !== deliveryType) return false;
    }

    //     if (selectedLogisticsType === "DRIVERS") {
    //   if (driverType && d.type !== driverType) return false;
    //   if (licenseType && d.license !== licenseType) return false;
    //   if (experience && parseInt(d.experience) < parseInt(experience)) return false;
    //   if (driverType && d.type !== driverType) return false;

    //   // Filter by license type
    //   if (licenseType && d.licenseType !== licenseType) return false;

    //   // Filter by experience (numeric comparison)
    //   if (experience) {
    //     const expNum = parseInt(d.experience); // convert "5 years" → 5
    //     if (expNum < parseInt(experience)) return false;
    //   }
    // }
    // PASSENGER filters
    if (selectedLogisticsType === "PASSENGER") {
      if (passengers && v.passengers < parseInt(passengers)) return false;
      if (rideType && v.rideType !== rideType) return false;
    }

    // SCHEDULED filter
    if (deliveryType === "SCHEDULED") {
      // Date & Time required
      if (!scheduledDate || !scheduledTime) return false;

      // Vehicle must support scheduled booking
      if (!v.scheduledAvailable) return false;


      // Agar vehicle ke availableDates hain to check karo
      if (v.availableDates && !v.availableDates.includes(scheduledDate)) {
        return false;
      }
    }


    return true;
  });

  // ✅ Locations ke liye readiness check
  const logisticsReadyForLocations = () => {
    if (selectedLogisticsType === "GOODS") {
      return capacity && distance && deliveryType;
    }
    if (selectedLogisticsType === "PASSENGER") {
      return passengers && rideType;
    }
    return false;
  };



  const PER_KM_RATE = 9; // for goods

  // State


  // Function to calculate distance between pickup and drop
  function calculateDistance(pickup, drop) {
    if (!pickup || !drop) return 0;

    const p = pickup.toLowerCase();
    const d = drop.toLowerCase();

    if (p.includes("patna") && d.includes("ranchi")) return 250;
    if (p.includes("delhi") && d.includes("jaipur")) return 280;
    if (p.includes("mumbai") && d.includes("pune")) return 160;

    return 50; // default
  }

  // Function to calculate price for GOODS
  const calculateGoodsPrice = () => {
    if (!pickupLocation || !dropLocation) {
      alert("Enter both Pickup and Drop locations");
      return;
    }

    const dist = calculateDistance(pickupLocation, dropLocation);
    setDistance(dist);

    let basePrice = dist * PER_KM_RATE;

    if (deliveryType === "EXPRESS") basePrice += 200;
    if (deliveryType === "SAME_DAY") basePrice += 100;
    if (deliveryType === "STANDARD") basePrice += 50;
    if (capacity.includes("kg")) basePrice += 50;

    setPrice(basePrice);
  };

  // Function to calculate price for PASSENGER
  const calculatePassengerPrice = () => {
    if (!pickupLocation || !dropLocation) {
      alert("Enter both Pickup and Drop locations");
      return;
    }

    const dist = calculateDistance(pickupLocation, dropLocation);
    setDistance(dist);

    let basePrice = passengers * 12; // dummy per passenger

    if (rideType === "TRIP") basePrice += 50;
    if (rideType === "GROUP") basePrice -= 20; // discount
    if (rideType === "RENTALS") basePrice += 100;
    if (rideType === "RESERVE") basePrice += 150;

    setPrice(basePrice);
  };

  // Generic handler for arrow button
  const handleCalculatePrice = () => {
    if (selectedLogisticsType === "GOODS") {
      calculateGoodsPrice();
    } else if (selectedLogisticsType === "PASSENGER") {
      calculatePassengerPrice();
    }
  }





  const geocodeAddress = async (address) => {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results[0]) {
          resolve(results[0].geometry.location);
        } else {
          reject(status);
        }
      });
    });
  };

  const handleOpenModal = async () => {
    setModalOpen(true);
    try {
      const location = await geocodeAddress(pickupLocation);
      setMarkerPosition({ lat: location.lat(), lng: location.lng() });
    } catch (error) {
     
    }
  };



  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${markerPosition.lat},${markerPosition.lng}&zoom=15&size=500x300&markers=color:red%7C${markerPosition.lat},${markerPosition.lng}&key=YOUR_API_KEY`;

  const handleConfirmPickup = () => {
    alert("✅ Pickup confirmed at " + pickupLocation);
    setModalOpen(false);
  };



  const handleLocationTypeChange = (e) => {
    const type = e.target.value;
    setLocationType(type);

    if (type === "Home") {
      // Reset fields for Home
      setArea("");
      setPincode("");
    } else if (type === "Office") {
      // Reset fields for Office
      setArea("");
      setPincode("");
    } else if (type === "Current") {
      getCurrentLocation();
    } else if (type === "Add") {
      // Clear fields for Add Location
      setArea("");
      setPincode("");
    }
  };

  
  return (
    <ThemeProvider theme={theme}>
      {/* Toggle Button */}
      <Box
        sx={{
          position: "fixed",
          top: isMobile ? "70px" : "70px",
          left: getToggleButtonLeft(),
          transition: "left 0.3s ease-in-out",
          zIndex: 1500,
        }}
        className="side-data-bar"
      >
        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            color: "#B276C3",
            padding: isSmallMobile ? "8px" : "12px",
          }}
        >
          <MenuIcon fontSize={getIconSize()} />
        </IconButton>
      </Box>

      {/* Sidebar Drawer */}
      <Drawer
        anchor="left"
        variant={isDesktop ? "persistent" : "temporary"}
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            marginTop: isMobile ? "60px" : "80px",
            overflowY: "auto",
            height: isMobile ? "calc(100vh - 60px)" : "calc(100vh - 80px)",
            border: "3px solid white",
            width: getSidebarWidth(),
            padding: "15px",
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {/* Filters Sidebar */}
        <div className={`filter-sidebar ${showFilters ? "active" : ""}`}>
          <div className="filter-header">
                      <h3>Filters</h3>
                      <button className="clear-filters" onClick={clearAll}>  clearAll</button>
                    </div>
          
                    {/* Search */}
                    <input
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search…"
                      className="filter-input"
                    />
                    <select
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                   className="filter-input"
                    style={{ padding: "10px", marginBottom: "-10px", width: "100%" }}
                 
                >
                  <option value="">Select Country</option>
                  {countries.map((country, idx) => (
                    <option key={idx} value={country}>
                      {country}
                    </option>
                  ))}
                </select>
          
                    {/* City (common) */}
                    <div style={{  width: "100%", margin: "20px auto",marginBottom:'-5px' }}>
                {/* City Select */}
                <select
                  value={selectedCity}
                  onChange={(e) => {
                    setSelectedCity(e.target.value);
                    setShowExtraFields(!!e.target.value); // show fields only if city is selected
                  }}
                  className="filter-select"
                >
                  <option value="">Select City</option>
                  <option value="Hyderabad">Hyderabad</option>
                  <option value="Bangalore">Bangalore</option>
                  <option value="Mumbai">Mumbai</option>
                  <option value="Chennai">Chennai</option>
                </select>
          
                {/* Show Extra Fields */}
                {showExtraFields && (
                  <div className="extra-fields" style={{ marginTop: "10px" }}>
                    {/* Location Type Dropdown */}
                    <select
                      value={locationType}
                      onChange={handleLocationTypeChange}
                      className="filter-select"
                       style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                    >
                      <option value="">Select Location Type</option>
                      <option value="Home">Home</option>
                      <option value="Office">Office</option>
                      <option value="Current">Current Location</option>
                      <option value="Add">Add Location</option>
                    </select>
          
                    {/* Fields appear based on selection */}
                    {(locationType === "Home" || locationType === "Office" || locationType === "Add") && (
                      <>
                        <input
                          type="text"
                          value={area}
                          onChange={(e) => setArea(e.target.value)}
                          placeholder="Enter Area"
                          className="filter-select"
                           style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
          
                        />
                        <input
                          type="text"
                          value={pincode}
                          onChange={(e) => setPincode(e.target.value)}
                          placeholder="Enter Pincode"
                          className="filter-select"
                           style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                        />
                        <select value={nearby} onChange={(e) => setNearby(e.target.value)}
                          className="filter-select" > 
                          
                          <option value="">Select Range</option> <option value="1">1 km</option> <option value="5">5 km</option> 
                          <option value="10">10 km</option> </select>
                      </>
                    )}
          
                    {locationType === "Current" && (
                      <>
                        <input type="text" value={area} readOnly className="filter-input" />
                        <input type="text" value={pincode} readOnly className="filter-input" />
                      </>
                    )}
                  </div>
                )}
              </div>
          
                    {/* Business Type (master selector) */}
                    <select
                      value={selectedBusinessType}
                      onChange={(e) => handleBusinessTypeChange(e.target.value)}
                      style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                      className="filter-input"
                    >
                      <option value="">Business Type</option>
                      <option value="FOOD_AND_BEVERAGES">Food & Beverages</option>
                      <option value="GROCERY_SERVICES">Fresh & Grocery</option> {/* New Option Added */}
                       <option value="CATERING_SERVICE">Catering & Services</option>
                      
                      {/* <option value="BANQUET_HALL">Banquet Hall</option> */}
                      {/* <option value="FRANCHISE">Franchise</option> */}
                      {/* <option value="CLOUD_KITCHEN">Cloud Kitchen</option> */}
                      <option value="LOGISTICS">Logistics & Supply</option>
                     
          
          
                      {/* You can keep or remove the extra catering variants above — they just demonstrate that catering flows are handled
                      from the business type selection. */}
                    </select>
          
                    {/* -----------------------
                    LOGISTICS BLOCK
                   ----------------------- */}
                    {selectedBusinessType === "LOGISTICS" && (
                      <div style={{ maxWidth: "500px", margin: "0 auto" }}>
                        {/* Logistics Type */}
                        <select
                          value={selectedLogisticsType}
                          onChange={(e) => {
                            setSelectedLogisticsType(e.target.value);
                            setPickupLocation("");
                            setDropLocation("");
                            setShowFilter(false);
                          }}
                          style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                          className="filter-input"
                        >
                          <option value="">Select Logistics Type</option>
                          <option value="GOODS">Goods / Cargo Delivery</option>
                          <option value="PASSENGER">Passenger Transport</option>
                          <option value="DRIVERS">Driver Service</option>
          
          
                        </select>
          
                        {/* GOODS Inputs */}
          
          
          
                        {selectedLogisticsType === "DRIVERS" && (
                          <div style={{ maxWidth: "500px", margin: "0 auto" }}>
                            {/* Driver Type */}
                            <select
                              value={driverType}
                              onChange={(e) => setDriverType(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            >
                              <option value="">Select Driver Type</option>
                              <option value="Car Driver">Car Driver</option>
                              <option value="Heavy Vehicle Driver">Heavy Vehicle Driver</option>
                              <option value="Bus Driver">Bus Driver</option>
                              <option value="Chauffeur">Chauffeur</option>
                            </select>
          
                            {/* License Type */}
                            <select
                              value={licenseType}
                              onChange={(e) => setLicenseType(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            >
                              <option value="">Select License Type</option>
                              <option value="LMV">LMV</option>
                              <option value="Heavy Motor Vehicle">Heavy Motor Vehicle</option>
                              <option value="Passenger Bus">Passenger Bus</option>
                              <option value="LMV + Commercial">LMV + Commercial</option>
                            </select>
          
                            {/* Experience Filter */}
                            <select
                              value={experience}
                              onChange={(e) => setExperience(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            >
                              <option value="">Select Experience</option>
                              <option value="1">1+ Years</option>
                              <option value="3">3+ Years</option>
                              <option value="5">5+ Years</option>
                              <option value="7">7+ Years</option>
                              <option value="10">10+ Years</option>
                            </select>
                          </div>
                        )}
          
          
          
                        {selectedLogisticsType === "GOODS" && (
                          <>
                            <input
                              type="text"
                              placeholder="Load / Capacity (e.g., 500kg)"
                              value={capacity}
                              onChange={(e) => setCapacity(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            />
          
                            {capacity && (
                              <select
                                value={deliveryType}
                                onChange={(e) => setDeliveryType(e.target.value)}
                                style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                              >
                                <option value="">Select Delivery Type</option>
                                <option value="SAME_DAY">Same-day</option>
                                <option value="EXPRESS">Express (2 hrs)</option>
                                <option value="STANDARD">Standard (24 hrs)</option>
                                <option value="SCHEDULED">Scheduled</option>
                              </select>
                            )}
          
                            {deliveryType === "SCHEDULED" && (
                              <>
                                <input
                                  type="date"
                                  value={scheduledDate}
                                  onChange={(e) => setScheduledDate(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                                <input
                                  type="time"
                                  value={scheduledTime}
                                  onChange={(e) => setScheduledTime(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                              </>
                            )}
                          </>
                        )}
          
                        {/* PASSENGER Inputs */}
                        {selectedLogisticsType === "PASSENGER" && (
                          <>
                            <input
                              type="number"
                              placeholder="Number of Passengers"
                              value={passengers}
                              onChange={(e) => setPassengers(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            />
                            <select
                              value={rideType}
                              onChange={(e) => setRideType(e.target.value)}
                              style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                            >
                              <option value="">Select Ride Type</option>
                              <option value="RENTALS">Rentals</option>
                              <option value="TRIP">Trip</option>
                              <option value="GROUP">Group Ride</option>
                              <option value="RESERVE">Reserve</option>
                            </select>
          
                            {rideType === "RESERVE" && (
                              <>
                                <input
                                  type="date"
                                  value={scheduledDate}
                                  onChange={(e) => setScheduledDate(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                                <input
                                  type="time"
                                  value={scheduledTime}
                                  onChange={(e) => setScheduledTime(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                              </>
                            )}
                          </>
                        )}
          
                        {/* Pickup / Drop */}
                        {selectedLogisticsType === "GOODS" &&
                          capacity && // capacity must be filled
                          deliveryType && (
                            (deliveryType !== "SCHEDULED" || (scheduledDate && scheduledTime)) && (
                              <div style={{ marginTop: "15px" }}>
                                <input
                                  type="text"
                                  placeholder="Pickup Location"
                                  value={pickupLocation}
                                  onChange={(e) => setPickupLocation(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                                <div style={{ position: "relative", width: "100%" }}>
                                  <input
                                    type="text"
                                    placeholder="Drop Location"
                                    value={dropLocation}
                                    onChange={(e) => setDropLocation(e.target.value)}
                                    style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                  />
                                  {pickupLocation && dropLocation && (
                                    <FaArrowRight
                                      onClick={calculateGoodsPrice}
                                      style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "blue",
                                        fontSize: "20px",
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            )
                          )}
          
                        {selectedLogisticsType === "PASSENGER" && rideType && logisticsReadyForLocations() && (
                          (rideType !== "RESERVE" || (scheduledDate && scheduledTime)) && (
                            <div style={{ marginTop: "15px" }}>
                              <input
                                type="text"
                                placeholder="Pickup Location"
                                value={pickupLocation}
                                onChange={(e) => setPickupLocation(e.target.value)}
                                style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                              />
                              <div style={{ position: "relative", width: "100%" }}>
                                <input
                                  type="text"
                                  placeholder="Drop Location"
                                  value={dropLocation}
                                  onChange={(e) => setDropLocation(e.target.value)}
                                  style={{ padding: "10px", marginBottom: "10px", width: "100%" }}
                                />
                                {pickupLocation && dropLocation && (
                                  <FaArrowRight
                                    onClick={calculateGoodsPrice}
                                    style={{
                                      position: "absolute",
                                      right: "12px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      color: "blue",
                                      fontSize: "20px",
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          )
                        )}
          
                        {/* Show Price */}
          
                      </div>
                    )}
                    {/* -----------------------
                    CATERING / FOOD BLOCK
                   ----------------------- */}
                    {selectedBusinessType === "CATERING_SERVICE" && (
                      <div style={{ marginTop: 12 }}>
                        {/* For catering flow we show cuisine -> dietary -> package/customize -> offers */}
                        <select
                          value={cuisine}
                          onChange={(e) => {
                            setCuisine(e.target.value);
                            setActiveStep(6);
                          }}
                          className={`filter-select ${activeStep === 5 ? "highlight-blink" : ""}`}
                        >
                          <option value="">Cuisine & Food Type</option>
                          <option value="NORTH">North Indian</option>
                          <option value="SOUTH">South Indian</option>
                          <option value="ITALIAN">Italian</option>
                          <option value="MEXICAN">Mexican</option>
                          <option value="THAI">Thai</option>
                          <option value="JAPANESE">Japanese</option>
                          <option value="CONTINENTAL">Continental</option>
                          <option value="FASTFOOD">Fast Food</option>
                          <option value="BAKERY">Bakery</option>
                          <option value="DESSERTS">Desserts</option>
                        </select>
          
                        {cuisine && (
                          <select
                            value={dietary}
                            onChange={(e) => {
                              setDietary(e.target.value);
                              setActiveStep(7);
                            }}
                            className={`filter-select ${activeStep === 6 ? "highlight-blink" : ""}`}
                          >
                            <option value="">Dietary Preferences</option>
                            <option value="VEG">Vegetarian</option>
                            <option value="NONVEG">Non-Vegetarian</option>
                            <option value="VEGAN">Vegan</option>
                            <option value="JAIN">Jain</option>
                            <option value="GLUTEN">Gluten-free</option>
                            <option value="HALAL">Halal</option>
                          </select>
                        )}
          
                        {cuisine && dietary && (
                          <div style={{ marginTop: "10px" }}>
                            <button
                              onClick={() => {
                                setCateringMode("PACKAGE");
                                setActiveStep(8);
                              }}
                              style={btnStyle}
                            >
                              Catering Package
                            </button>
                            <button
                              onClick={() => {
                                setCateringMode("CUSTOMIZE");
                                setActiveStep(8);
                              }}
                              style={{ ...btnStyle, background: "#28a745" }}
                            >
                              Customize Menu
                            </button>
                          </div>
                        )}
          
                        {/* Offer Type & SubOffer (same as earlier) */}
                        <select
                          value={subCategory}
                          onChange={(e) => {
                            setSubCategory(e.target.value);
                            setActiveStep(9);
                          }}
                          className={`filter-select ${activeStep === 8 ? "highlight-blink" : ""}`}
                          style={{ marginTop: 10 }}
                        >
                          <option value="">Select Offer Type</option>
                          {Object.keys(subOffersMap).map((offerType) => (
                            <option key={offerType} value={offerType}>
                              {offerType}
                            </option>
                          ))}
                        </select>
          
                        {subCategory && (
                          <select
                            value={subOffer}
                            onChange={(e) => {
                              setSubOffer(e.target.value);
                              setActiveStep(10);
                            }}
                            className={`filter-select ${activeStep === 9 ? "highlight-blink" : ""}`}
                            style={{ marginTop: 8 }}
                          >
                            <option value="">Select Sub-Offer</option>
                            {subOffersMap[subCategory]?.map((offer, index) => (
                              <option key={index} value={offer}>
                                {offer}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    )}
          
                    {/* -----------------------
                    FOOD & BEVERAGES / OUTLET BLOCK (example)
                   ----------------------- */}
                    {(selectedBusinessType === "FOOD_AND_BEVERAGES" ||
                      selectedBusinessType === "CLOUD_KITCHEN" ||
                      selectedBusinessType === "BANQUET_HALL") && (
                        <div style={{ marginTop: 12 }}>
                          <select
                            value={selectedOutletType}
                            onChange={(e) => {
                              setSelectedOutletType(e.target.value);
                              setActiveStep(4);
                            }}
                            className={`filter-select ${activeStep === 3 ? "highlight-blink" : ""}`}
                          >
                            <option value="">Select Outlet Type</option>
                            <option value="HOTEL">Hotel</option>
                            <option value="RESTAURANT">Restaurant</option>
                            {/* <option value="CAFE">Cafe</option>
                            <option value="BAR">Bar / Pub / Lounge</option>
                            <option value="FRANCHISE">Franchise</option>
                            <option value="BAKERY">Bakery / Dessert Shop</option>
                            <option value="FOODCOURT">Food Court</option> */}
                            <option value="STREETFOOD">Street Food</option>
                            <option value="OTHER">Any</option>
                          </select>
          
                          {selectedOutletType === "OTHER" && (
                            <input
                              type="text"
                              placeholder="Enter custom outlet type"
                              value={customType}
                              onChange={(e) => setCustomType(e.target.value)}
                              className="filter-select"
                              style={{
                                marginTop: "10px",
                                padding: "8px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                width: "100%",
                              }}
                            />
                          )}
          
          
                          {/* {selectedBranch && (
                            <select
                              value={subCategory}
                              onChange={(e) => {
                                setSubCategory(e.target.value);
                                setActiveStep(6);
                              }}
                              className="filter-select"
                              style={{ marginTop: 8 }}
                            >
                              <option value="">Select Sub-Category</option>
                              {businessSubCategories[selectedBranch]?.map((sub) => (
                                <option key={sub} value={sub}>
                                  {sub}
                                </option>
                              ))}
                            </select>
                          )} */}
                        </div>
                      )}
          
                    {/* -----------------------
                   SERVICE TYPE (kept separate but WITHOUT CATERING_SERVICE option)
                   show only when relevant to reduce noise
                   ----------------------- */}
                    {(selectedBusinessType === "FOOD_AND_BEVERAGES" ||
                      selectedBusinessType === "CLOUD_KITCHEN" ||
                      selectedBusinessType === "BANQUET_HALL") && (
                        <div style={{ marginTop: 12 }}>
                          {/* <select
                            value={businessModel}
                            onChange={(e) => {
                              setBusinessModel(e.target.value);
                              setActiveStep(7);
                            }}
                            className={`filter-select ${activeStep === 5 ? "highlight-blink" : ""}`}
                          >
                            <option value="">Service Type</option>
                            
                            <option value="TABLE_DINE_IN">Dine In</option>
                            <option value="DINE_IN">Quick Dining</option>
                            <option value="TAKEAWAY">Take Away</option>
                            <option value="DELIVERY">Delivery</option>
                            <option value="ANY">Any</option>
                          </select> */}
          
          
                          <select
                            value={businessModel}
                            onChange={(e) => {
                              handleBusinessModelChange(e);
                              setBusinessModel(e.target.value);
                              setActiveStep(7);
                            }}
                            className={`filter-select ${activeStep === 5 ? "highlight-blink" : ""}`}
                          >
                            <option value="">Service Type</option>
          
                            <option value="TABLE_DINE_IN">Dine In</option>
                            <option value="DINE_IN">Quick Dining</option>
                            <option value="TAKEAWAY">Take Away</option>
                            <option value="DELIVERY">Delivery</option>
                            <option value="any">Any</option>
                          </select>
          
          
                          {businessModel === "ANY" && (
                            <input
                              type="text"
                              placeholder="Enter custom service type"
                              value={customType}
                              onChange={(e) => setCustomType(e.target.value)}
                              className="filter-select"
                              style={{
                                marginTop: "10px",
                                padding: "8px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                width: "100%",
                              }}
                            />
                          )}
                        </div>
          
                      )}
                  </div>
          
          
                  {/* Cards Container - Column 7 */}
                  <div style={{ height: '650px', overflow: 'auto', scrollbarWidth: 'none' }} className="cards-container">
                    {cateringMode === "PACKAGE" ? (
                      <div className="catering-package-view">
                        <Cateringall />
                      </div>
                    ) : cateringMode === "CUSTOMIZE" ? (
                      <div className="catering-package-view">
                        <Catreningitem />
                      </div>
                      // ) : showFilter ? (
                      //   <div className="catering-package-view">
                      //     <Logisticsserivices />
                      //   </div>
          
                    ) : selectedBusinessType === "LOGISTICS" && (
                      <div style={{ marginTop: "20px" }}>
                        {filteredVehicles.length > 0 ? (
                          filteredVehicles.map((v) => {
                            // Choose icon based on vehicle type/name
                            let VehicleIcon = FaCar;
                            if (v.type === "GOODS") VehicleIcon = FaTruck;
                            if (v.name.toLowerCase().includes("bus")) VehicleIcon = FaBus;
                            if (v.name.toLowerCase().includes("bike")) VehicleIcon = FaMotorcycle;
                            if (v.name.toLowerCase().includes("van")) VehicleIcon = FaShuttleVan;
                            const finalPrice = distance > 0 ? distance * PER_KM_RATE : null;
                            return (
                              <div
                                key={v.id}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  border: "1px solid #ddd",
                                  borderRadius: "12px",
                                  padding: "15px",
                                  marginBottom: "18px",
                                  boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                                  backgroundColor: "#fff",
                                }}
                              >
                                {/* Left Image */}
                                <img
                                  src={v.image}
                                  alt={v.name}
                                  style={{
                                    width: "140px",
                                    height: "78px",
                                    borderRadius: "10px",
                                    objectFit: "cover",
                                    marginRight: "18px",
                                  }}
                                />
          
                                {/* Middle Content */}
                                <div style={{ flex: 1 }}>
                                  <h3
                                    style={{
                                      margin: "0 0 6px",
                                      fontSize: "18px",
                                      fontWeight: "600",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <VehicleIcon style={{ color: "#007BFF" }} />
                                    {v.name}
                                    {price && (
                                      <span
                                        style={{
                                          color: "#28a745",
                                          fontSize: "16px",
                                          marginLeft: "8px",
                                        }}
                                      >
                                        ₹{price}
                                      </span>
                                    )}
                                  </h3>
                                  {distance > 0 && (
                                    <p style={{ margin: "3px 0" }}>Distance: {distance} km</p>
                                  )}
                                  {v.capacity && <p style={{ margin: "3px 0" }}>Capacity: {v.capacity}</p>}
                                  {v.distance && <p style={{ margin: "3px 0" }}>Distance: {v.distance}</p>}
                                  {v.deliveryType && <p style={{ margin: "3px 0" }}>Delivery: {v.deliveryType}</p>}
                                  {v.passengers && <p style={{ margin: "3px 0" }}>Passengers: {v.passengers}</p>}
                                  {v.rideType && <p style={{ margin: "3px 0" }}>Ride Type: {v.rideType}</p>}
                                  {(pickupLocation || dropLocation) && (
                                    <p style={{ margin: "3px 0", fontStyle: "italic", color: "#555" }}>
                                      Route: {pickupLocation || "N/A"} → {dropLocation || "N/A"}
                                    </p>
                                  )}
                                </div>
          
                                {/* Right Action */}
                                <div style={{ textAlign: "right" }}>
                                  <>
                                    <button
                                      style={{
                                        padding: "8px 18px",
                                        backgroundColor: "#007BFF",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                      }}
                                      onClick={handleOpenModal}
                                      onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
                                      onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
                                    >
                                      Book
                                    </button>
          
                                    <Modal
                                      isOpen={modalOpen}
                                      onRequestClose={() => setModalOpen(false)}
                                      style={{
                                        overlay: {
                                          backgroundColor: "rgba(0,0,0,0.5)",
                                          zIndex: 1000,
                                        },
                                        content: {
                                          maxWidth: "520px",
                                          margin: "auto",
                                          borderRadius: "12px",
                                          padding: "20px",
                                          border: "none",
                                          backgroundColor: "#fff",
                                        },
                                      }}
                                    >
                                      <h2
                                        style={{ marginBottom: "15px", textAlign: "center", color: "#333" }}
                                      >
                                        📍 Pickup & Drop Route
                                      </h2>
          
                                      {/* Google Map Iframe */}
                                      {pickupLocation && dropLocation && (
                                        <iframe
                                          title="map"
                                          width="100%"
                                          height="250"
                                          style={{
                                            marginTop: "15px",
                                            borderRadius: "10px",
                                            border: "1px solid #ddd",
                                          }}
                                          src={`https://www.google.com/maps?q=${encodeURIComponent(
                                            pickupLocation + " to " + dropLocation
                                          )}&z=13&output=embed`}
                                        />
                                      )}
          
                                      {/* Pickup Address Box */}
                                      <div
                                        style={{
                                          marginTop: "15px",
                                          padding: "12px",
                                          border: "1px solid #ddd",
                                          borderRadius: "8px",
                                          backgroundColor: "#f9f9f9",
                                          fontSize: "14px",
                                          color: "#444",
                                        }}
                                      >
                                        <strong>Pickup Address:</strong>
                                        <div
                                          style={{ marginTop: "5px", display: "flex", alignItems: "center" }}
                                        >
                                          <span style={{ marginRight: "8px" }}>📍</span>
                                          {pickupLocation}
                                        </div>
                                      </div>
          
                                      {/* Confirm button */}
                                      <div style={{ textAlign: "right", marginTop: "20px" }}>
                                        <button
                                          style={{
                                            padding: "10px 20px",
                                            backgroundColor: "#28a745",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                          }}
                                          onClick={handleConfirmPickup}
                                          onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
                                          onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
                                        >
                                          ✅ Confirm Pickup
                                        </button>
                                      </div>
                                    </Modal>
          
                                  </>
          
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p></p>
                        )}
                      </div>
                    )}
          
                    <>
                      {selectedLogisticsType === "DRIVERS" && (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                            gap: "20px",
                            marginTop: "20px",
                          }}
                        >
                          {filteredDrivers.map((d) => (
                            <div
                              key={d.id}
                              style={{
                                border: "1px solid #ddd",
                                borderRadius: "12px",
                                padding: "15px",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.1)",
                                backgroundColor: "#fff",
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                <img
                                  src={d.image}
                                  alt={d.name}
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                  }}
                                />
                                <div>
                                  <h3 style={{ margin: "0 0 5px", fontSize: "18px" }}>{d.name}</h3>
                                  <p style={{ margin: "3px 0", fontSize: "14px" }}>Type: {d.type}</p>
                                </div>
                              </div>
          
                              {/* Details Left Aligned */}
                              <div style={{ marginTop: "10px", fontSize: "14px" }}>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <span>Experience:</span> <span>{experience}</span>
                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                  <span>License:</span> <span>{licenseType}</span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontWeight: "600",
                                    color: "green",
                                  }}
                                >
                                  <span>Salary:</span> <span>{d.salary}</span>
                                </div>
                              </div>
          
                              {/* Hire Button */}
                              <button
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  backgroundColor: "#007BFF",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  marginTop: "12px",
                                }}
                                onClick={() => handleHireClick(d)}
                                onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
                                onMouseOut={(e) => (e.target.style.backgroundColor = "#007BFF")}
                              >
                                Hire
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
          
          
                      {/* Popup Modal */}
                      <Modal
                        isOpen={showModal}
                        onRequestClose={() => setShowModal(false)}
                        style={{
                          content: {
                            maxWidth: "500px",
                            height: "420px",
                            marginTop: '123px',
                            margin: "auto",
                            borderRadius: "16px",
                            padding: "20px 25px",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                            border: "none",
                          },
                        }}
                      >
                        {/* Driver Info Header */}
                        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                          <img
                            src={selectedDriver?.image}
                            alt={selectedDriver?.name}
                            style={{
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              marginRight: "15px",
                              border: "2px solid #007BFF",
                            }}
                          />
                          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>
                            Hire {selectedDriver?.name}
                          </h2>
                        </div>
          
                        {/* Hire Form */}
                        <form onSubmit={handleSubmit}>
                          <input
                            type="text"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            style={styles.input}
                            required
                          />
                          <input
                            type="text"
                            placeholder="Mobile Number"
                            value={formData.mobile}
                            onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                            style={styles.input}
                            required
                          />
                          <input
                            type="text"
                            placeholder="Pickup Location"
                            value={formData.pickup}
                            onChange={(e) => setFormData({ ...formData, pickup: e.target.value })}
                            style={styles.input}
                            required
                          />
                          <input
                            type="text"
                            placeholder="Drop Location"
                            value={formData.drop}
                            onChange={(e) => setFormData({ ...formData, drop: e.target.value })}
                            style={styles.input}
                            required
                          />
          
                          {/* Show Map only if pickup & drop both are entered */}
                          {formData.pickup && formData.drop && (
                            <iframe
                              title="map"
                              width="100%"
                              height="250"
                              style={{
                                marginTop: "15px",
                                borderRadius: "10px",
                                border: "1px solid #ddd",
                              }}
                              src={`https://www.google.com/maps?q=${encodeURIComponent(
                                formData.pickup + " to " + formData.drop
                              )}&z=13&output=embed`}
                            />
                          )}
          
                          <button type="submit" style={styles.button}>
                            Confirm Hire
                          </button>
                        </form>
                      </Modal>
          
                  
                    </>
                    </div>
      </Drawer>
    </ThemeProvider>
  );
};

export default Cloudsidebar;
